import script from "./consumptionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./consumptionPage.vue?vue&type=script&setup=true&lang=js"

import "./consumptionPage.vue?vue&type=style&index=0&id=0da8c59f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da8c59f"]])

export default __exports__